<div class="modal-wrap">
    <div class="modal-header position-relative">
        <div class="d-flex align-items-center justify-content-between w-100">
            <h4 class="upload-img-text">Upload Images</h4>
            <div class="d-flex align-items-center model-joint-wrapper">
                <h6 *ngIf="JointData?.namePrimary" class="joint-id-text">
                    Joint Id<span class="joint-id">{{ JointData?.namePrimary }}</span>
                </h6>
                <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="closeClick()"><i
                        class="flaticon2-cross"></i></a>
            </div>
        </div>
    </div>

    <div class="modal-body output-lable">
        <div class="d-flex align-items-center justify-content-center my-14" *ngIf="!showCropper">
            <img src="../../../../../../../assets/media/logos/25.gif" />
        </div>

        <div *ngIf="croppedImageArray.length">
            <image-cropper *ngIf="croppedImageArray[currentIndex]?.url"
                [imageURL]="croppedImageArray[currentIndex]?.url" [maintainAspectRatio]="true" [aspectRatio]="ratio"
                [resizeToWidth]="400" [cropperMinWidth]="400" [onlyScaleDown]="true"
                [canvasRotation]="LoadcanvasRotation()" [transform]="LoadTransform()" [alignImage]="'center'"
                [imageQuality]="100" [style.display]="showCropper ? null : 'none'" format="png"
                [backgroundColor]="'white'" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                (loadImageFailed)="loadImageFailed()"></image-cropper>
        </div>
        <div class="btn-group-wrap">
            <a (click)="rotateLeft()"><svg focusable="false" width="18" height="18" viewBox="0 0 24 24" class="NMm5M">
                    <path
                        d="M19.36 19.36A8.95 8.95 0 0 1 13 22c-1.49 0-2.98-.38-4.33-1.12l1.49-1.49a6.973 6.973 0 0 0 7.79-1.44 7.007 7.007 0 0 0 0-9.9A6.973 6.973 0 0 0 13 6h-.17l1.59 1.59L13 9 9 5l4-4 1.41 1.41L12.83 4h.18c2.3 0 4.6.88 6.35 2.64a8.98 8.98 0 0 1 0 12.72zm-5.72-6.24l-6.36 6.36-6.36-6.36 6.36-6.36 6.36 6.36zm-6.37 3.54l3.54-3.54-3.54-3.54-3.54 3.54 3.54 3.54z">
                    </path>
                </svg>Left</a>
            <a (click)="rotateRight()"><svg enable-background="new 0 0 24 24" focusable="false" height="18"
                    viewBox="0 0 24 24" width="18" class="NMm5M">
                    <g>
                        <rect fill="none" height="24" width="24"></rect>
                    </g>
                    <g>
                        <g>
                            <path
                                d="M2,13c0,4.97,4.03,9,9,9c1.76,0,3.4-0.51,4.79-1.38l-1.46-1.46C13.34,19.69,12.2,20,11,20c-3.86,0-7-3.14-7-7s3.14-7,7-7 h0.17L9.59,7.59L11,9l4-4l-4-4L9.58,2.41L11.17,4H11C6.03,4,2,8.03,2,13z M11,13l6,6l6-6l-6-6L11,13z M17,16.17L13.83,13L17,9.83 L20.17,13L17,16.17z">
                            </path>
                        </g>
                    </g>
                </svg>Right</a>

            <a (click)="resetImage()"><i class="fa fa-undo" aria-hidden="true"></i> Reset Image</a>

            <a (click)="zoomOut()"><i class="fa fa-minus" aria-hidden="true"></i> Zoom</a>
            <a (click)="zoomIn()"><i class="fa fa-plus" aria-hidden="true"></i> Zoom </a>
        </div>

        <mat-tab-group class="image-wrapper">
            <mat-tab *ngFor="let imageUrl of croppedImageArray; let i = index">
                <ng-template mat-tab-label>
                    <div class="image-area">
                        <img src="{{ imageUrl?.url }}" alt="Image" (click)="selectImg(i)" />
                        <a class="remove-image" (click)="deleteSelectedImage(i)"><i class="flaticon2-cross"></i></a>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="imgType == 'carousel'">
                <ng-template mat-tab-label>
                    <div class="add-new-wrpper" (click)="openFile()">
                        <i class="fa fa-plus" aria-hidden="true">
                            <input #fileInput id="fileInput" (change)="handleFileSelect($event)" accept="image/*"
                                type="file" style="display: none" /></i>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <div class="next-btn-wrap">
            <button class="primary-ebtn"
                [disabled]="this.croppedImageArrayCopy?.length == 0 || !this.croppedImageArrayCopy"
                (click)="nextClick()">Next</button>
        </div>
    </div>
</div>